
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/moja-karta/zmien-numer",
      function () {
        return require("private-next-pages/moje-konto/moja-karta/zmien-numer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/moja-karta/zmien-numer"])
      });
    }
  